// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditBlogDetails-commonHeaderAdmin-EVTQG {
	position: fixed !important;
}

.EditBlogDetails-adminLayout-y1g5e {
	padding-top: 64px !important;
}

.EditBlogDetails-box-PHAPo h2 {
	font-size: 21px;
	font-weight: 600;
}

.EditBlogDetails-exportLink-Mr_Z9 {
	margin-bottom: -29px;
}

.EditBlogDetails-blockCenter-GnUHS {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.EditBlogDetails-panelHeader-t1tq_ {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.EditBlogDetails-currencyselect-uOiYp {
	width: 100%;
	margin-right: 0px;
}

.EditBlogDetails-panelHeader-t1tq_ {
	overflow: hidden;
	position: relative;
}

.EditBlogDetails-mar0-pwBx7 {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.EditBlogDetails-blockCenter-GnUHS {
		padding: 0px;
	}

	.EditBlogDetails-panelHeader-t1tq_ {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.EditBlogDetails-sideAdminPageWrapper-s0wnQ {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.EditBlogDetails-panelHeader-t1tq_ {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.EditBlogDetails-table-WoHEI {
	display: table;
}

.EditBlogDetails-tableRow-CRSTb {
	display: table-row;
}

.EditBlogDetails-tableCell-R6EuU {
	display: table-cell;
	float: none;
}

.EditBlogDetails-formGroup-utgnx {
	margin-bottom: 6px;
}

.EditBlogDetails-select-kJWJu {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.EditBlogDetails-noMargin-sTmk3 {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.EditBlogDetails-exportLink-Mr_Z9 {
	padding-top: 10px;
	padding-right: 10px;
}

.EditBlogDetails-labelTextNew-lI1LI {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditBlogDetails-displayInline-AVHZA {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.EditBlogDetails-btnUPdate-hvKzU {
	display: inline-block;
}

.EditBlogDetails-btnModalDelete-l63_y {
	display: inline-block;
	margin-left: 15px;
}

.EditBlogDetails-radioBtn-P7Caj {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.EditBlogDetails-backgroundImg-GKaz6 {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.EditBlogDetails-btnUPdate-hvKzU {
		display: block;
		margin-bottom: 12px;
	}

	.EditBlogDetails-btnModalDelete-l63_y {
		display: block;
		margin-left: 0px;
	}

	.EditBlogDetails-btnWidth-HOHBF {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.EditBlogDetails-bannerImageBg-AUcTt {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.EditBlogDetails-bannerDelete-hvI4G {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.EditBlogDetails-modalRoot-Y9F07 {
	padding: 32px;
}

.EditBlogDetails-modalBorderBottom-N2crA {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.EditBlogDetails-logInModalBody-Iugst {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.EditBlogDetails-exportSection-fe73z {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.EditBlogDetails-exportSectionGridSub-KuFMe {
	grid-template-columns: 50% 49% !important;
}

.EditBlogDetails-exportText-k75r9 {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.EditBlogDetails-exportLinkImg-o0YIQ {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.EditBlogDetails-vtrMiddle-LbMoo {
	vertical-align: middle;
}

.EditBlogDetails-exportImg-kKXxG {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.EditBlogDetails-profileViewlabel-YSvM6 {
	display: inline-block;
	width: 38%
}

.EditBlogDetails-profileViewMainContent-ZI7zW {
	display: inline-block;
	width: 62%;
}

.EditBlogDetails-profileViewMain-Ek5HA {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.EditBlogDetails-profileViewInner-LNOzl {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.EditBlogDetails-profileImageSection-XA1WG {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.EditBlogDetails-lastviewInner-WV_hX {
	padding: 10px;
}

.EditBlogDetails-whyHostHoriLine-kQ5Ao {
	margin: 30px 0;
}

.EditBlogDetails-tableGrid-aXaOa {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.EditBlogDetails-headingContent-NieU2 {
	font-size: 18px;
	font-weight: 500;
}

.EditBlogDetails-refundTextColor-S5C_p {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.EditBlogDetails-dividerLine-HAz2y {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.EditBlogDetails-smallContent-jaTI_ {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.EditBlogDetails-sideAdminPageWrapper-s0wnQ {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.EditBlogDetails-sideAdminPageWrapper-s0wnQ {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.EditBlogDetails-exportSection-fe73z {
		grid-template-columns: 100%;
	}

	.EditBlogDetails-exportSectionGridSub-KuFMe {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.EditBlogDetails-profileViewlabel-YSvM6 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.EditBlogDetails-profileViewMainContent-ZI7zW {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.EditBlogDetails-ChangeToUpperCase-M62mk {
	text-transform: uppercase
}

.EditBlogDetails-noBorder-fLabq {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.EditBlogDetails-siteAdminHeading-vtJIo {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditBlogDetails-siteAdminSubHeading-Wdl6b {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditBlogDetails-adminFormDivider-_FoEd {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.EditBlogDetails-errorMessage-xz8tJ {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.EditBlogDetails-panelHeader-t1tq_ {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.EditBlogDetails-formGroup-utgnx {
  margin-bottom: 6px;
}

.EditBlogDetails-select-kJWJu {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.EditBlogDetails-labelText-iAnAc {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.EditBlogDetails-space1-Qo4Uc {
	margin-bottom: 6px !important;
}

.EditBlogDetails-space2-MwzVE {
	margin-bottom: 12px !important;
}

.EditBlogDetails-space3-CQPUR {
	margin-bottom: 18px !important;
}

.EditBlogDetails-space4-oj1YH {
	margin-bottom: 24px !important;
}

.EditBlogDetails-space5-S4oCn {
	margin-bottom: 30px !important;
}

.EditBlogDetails-space6-YQGHp {
	margin-bottom: 36px !important;
}

.EditBlogDetails-space7-lRH3L {
	margin-bottom: 42px !important;
}

.EditBlogDetails-spaceTop8-wJEHu {
	margin-bottom: 48px !important;
}

.EditBlogDetails-spaceTop1-IEP1u {
	margin-top: 6px !important;
}

.EditBlogDetails-spaceTop2-ybz7M {
	margin-top: 12px !important;
}

.EditBlogDetails-spaceTop3-BcPR_ {
	margin-top: 18px !important;
}

.EditBlogDetails-spaceTop4-kpTGQ {
	margin-top: 24px !important;
}

.EditBlogDetails-spaceTop5-trc4x {
	margin-top: 30px !important;
}

.EditBlogDetails-spaceTop6-cvHOj {
	margin-top: 36px !important;
}

.EditBlogDetails-spaceTop7-HMkeP {
	margin-top: 42px !important;
}

.EditBlogDetails-spaceTop8-wJEHu {
	margin-top: 48px !important;
}

.EditBlogDetails-noMargin-sTmk3 {
	margin: 0px !important;
}

.EditBlogDetails-padding1-BIcss {
	padding-bottom: 6px !important;
}

.EditBlogDetails-padding2-rw3No {
	padding-bottom: 12px !important;
}

.EditBlogDetails-padding3-sB2fW {
	padding-bottom: 18px !important;
}

.EditBlogDetails-padding4-cu5vq {
	padding-bottom: 24px !important;
}

.EditBlogDetails-padding5-Uorvz {
	padding-bottom: 30px !important;
}

.EditBlogDetails-padding6-v0JCQ {
	padding-bottom: 36px !important;
}

.EditBlogDetails-padding7-J3ZpO {
	padding-bottom: 42px !important;
}

.EditBlogDetails-paddingTop1-psuLC {
	padding-top: 6px !important;
}

.EditBlogDetails-paddingTop2-RwdPc {
	padding-top: 12px !important;
}

.EditBlogDetails-paddingTop3-xJq3u {
	padding-top: 18px !important;
}

.EditBlogDetails-paddingTop4-ASHJ_ {
	padding-top: 24px !important;
}

.EditBlogDetails-paddingTop5-oabcc {
	padding-top: 30px !important;
}

.EditBlogDetails-paddingTop6-g7qM5 {
	padding-top: 36px !important;
}

.EditBlogDetails-paddingTop7-xKUCO {
	padding-top: 42px !important;
}

.EditBlogDetails-noPadding-dlsIF {
	padding: 0px !important;
}

.EditBlogDetails-textBold-ub_b7 {
	font-weight: 500 !important;
}

.EditBlogDetails-textBolder-hqnwx {
	font-weight: 700 !important;
}

.EditBlogDetails-textNormal-asP7D {
	font-weight: normal !important;
}

.EditBlogDetails-spaceBottom20-ucbf5 {
	margin-bottom: 20px;
}

.EditBlogDetails-spaceBottom10-LsfE2 {
	margin-bottom: 10px;
}

.EditBlogDetails-marginNone-WyU_d {
	margin: 0;
}

.EditBlogDetails-spaceBottom15-X4mwU {
	margin-bottom: 15px;
}

.EditBlogDetails-marginTopNone-gUYuF {
	margin-top: 0;
}

.EditBlogDetails-spaceTop11-MyAoQ {
	margin-top: 11px;
}

.EditBlogDetails-spaceTop21-lWqev {
	margin-top: 21px;
}

.EditBlogDetails-spaceTop20-xtYB4 {
	margin-top: 20px;
}

.EditBlogDetails-spaceTop10-ZuZ2d {
	margin-top: 10px;
}

/*New Design Text Colors */

.EditBlogDetails-textDarkBlue-CXXg8 {
	color: rgb(20, 39, 94) !important;
}

.EditBlogDetails-textLightBlue-kCO3C {
	color: rgb(57, 87, 106) !important;
}

.EditBlogDetails-textLightSandleGreen-TV3Gn {
	color: rgb(76, 86, 41) !important;
}

.EditBlogDetails-textLightBrown-Chrrs {
	color: rgb(115, 79, 33) !important;
}

.EditBlogDetails-textMediumMaroon-shzxs {
	color: rgb(87, 37, 51) !important;
}

.EditBlogDetails-textBrown-SiHYH {
	color: rgb(160, 47, 24) !important;
}

.EditBlogDetails-textMaroon-yVMWU {
	color: rgb(155, 49, 67) !important;
}

.EditBlogDetails-textDarkBrown-hE8Ar {
	color: rgb(83, 18, 16) !important;
}

.EditBlogDetails-textMediumBrown-aWcmo {
	color: rgb(142, 28, 10) !important;
}

.EditBlogDetails-textSkyBlue-tC_rp {
	color: rgb(37, 117, 141) !important;
}

.EditBlogDetails-textGray-cA7_0 {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `EditBlogDetails-commonHeaderAdmin-EVTQG`,
	"adminLayout": `EditBlogDetails-adminLayout-y1g5e`,
	"box": `EditBlogDetails-box-PHAPo`,
	"exportLink": `EditBlogDetails-exportLink-Mr_Z9`,
	"blockCenter": `EditBlogDetails-blockCenter-GnUHS`,
	"panelHeader": `EditBlogDetails-panelHeader-t1tq_`,
	"currencyselect": `EditBlogDetails-currencyselect-uOiYp`,
	"mar0": `EditBlogDetails-mar0-pwBx7`,
	"sideAdminPageWrapper": `EditBlogDetails-sideAdminPageWrapper-s0wnQ`,
	"table": `EditBlogDetails-table-WoHEI`,
	"tableRow": `EditBlogDetails-tableRow-CRSTb`,
	"tableCell": `EditBlogDetails-tableCell-R6EuU`,
	"formGroup": `EditBlogDetails-formGroup-utgnx`,
	"select": `EditBlogDetails-select-kJWJu`,
	"noMargin": `EditBlogDetails-noMargin-sTmk3`,
	"labelTextNew": `EditBlogDetails-labelTextNew-lI1LI`,
	"displayInline": `EditBlogDetails-displayInline-AVHZA`,
	"btnUPdate": `EditBlogDetails-btnUPdate-hvKzU`,
	"btnModalDelete": `EditBlogDetails-btnModalDelete-l63_y`,
	"radioBtn": `EditBlogDetails-radioBtn-P7Caj`,
	"backgroundImg": `EditBlogDetails-backgroundImg-GKaz6`,
	"btnWidth": `EditBlogDetails-btnWidth-HOHBF`,
	"bannerImageBg": `EditBlogDetails-bannerImageBg-AUcTt`,
	"bannerDelete": `EditBlogDetails-bannerDelete-hvI4G`,
	"modalRoot": `EditBlogDetails-modalRoot-Y9F07`,
	"modalBorderBottom": `EditBlogDetails-modalBorderBottom-N2crA`,
	"logInModalBody": `EditBlogDetails-logInModalBody-Iugst`,
	"exportSection": `EditBlogDetails-exportSection-fe73z`,
	"exportSectionGridSub": `EditBlogDetails-exportSectionGridSub-KuFMe`,
	"exportText": `EditBlogDetails-exportText-k75r9`,
	"exportLinkImg": `EditBlogDetails-exportLinkImg-o0YIQ`,
	"vtrMiddle": `EditBlogDetails-vtrMiddle-LbMoo`,
	"exportImg": `EditBlogDetails-exportImg-kKXxG`,
	"profileViewlabel": `EditBlogDetails-profileViewlabel-YSvM6`,
	"profileViewMainContent": `EditBlogDetails-profileViewMainContent-ZI7zW`,
	"profileViewMain": `EditBlogDetails-profileViewMain-Ek5HA`,
	"profileViewInner": `EditBlogDetails-profileViewInner-LNOzl`,
	"profileImageSection": `EditBlogDetails-profileImageSection-XA1WG`,
	"lastviewInner": `EditBlogDetails-lastviewInner-WV_hX`,
	"whyHostHoriLine": `EditBlogDetails-whyHostHoriLine-kQ5Ao`,
	"tableGrid": `EditBlogDetails-tableGrid-aXaOa`,
	"headingContent": `EditBlogDetails-headingContent-NieU2`,
	"refundTextColor": `EditBlogDetails-refundTextColor-S5C_p`,
	"dividerLine": `EditBlogDetails-dividerLine-HAz2y`,
	"smallContent": `EditBlogDetails-smallContent-jaTI_`,
	"ChangeToUpperCase": `EditBlogDetails-ChangeToUpperCase-M62mk`,
	"noBorder": `EditBlogDetails-noBorder-fLabq`,
	"siteAdminHeading": `EditBlogDetails-siteAdminHeading-vtJIo`,
	"siteAdminSubHeading": `EditBlogDetails-siteAdminSubHeading-Wdl6b`,
	"adminFormDivider": `EditBlogDetails-adminFormDivider-_FoEd`,
	"errorMessage": `EditBlogDetails-errorMessage-xz8tJ`,
	"labelText": `EditBlogDetails-labelText-iAnAc`,
	"space1": `EditBlogDetails-space1-Qo4Uc`,
	"space2": `EditBlogDetails-space2-MwzVE`,
	"space3": `EditBlogDetails-space3-CQPUR`,
	"space4": `EditBlogDetails-space4-oj1YH`,
	"space5": `EditBlogDetails-space5-S4oCn`,
	"space6": `EditBlogDetails-space6-YQGHp`,
	"space7": `EditBlogDetails-space7-lRH3L`,
	"spaceTop8": `EditBlogDetails-spaceTop8-wJEHu`,
	"spaceTop1": `EditBlogDetails-spaceTop1-IEP1u`,
	"spaceTop2": `EditBlogDetails-spaceTop2-ybz7M`,
	"spaceTop3": `EditBlogDetails-spaceTop3-BcPR_`,
	"spaceTop4": `EditBlogDetails-spaceTop4-kpTGQ`,
	"spaceTop5": `EditBlogDetails-spaceTop5-trc4x`,
	"spaceTop6": `EditBlogDetails-spaceTop6-cvHOj`,
	"spaceTop7": `EditBlogDetails-spaceTop7-HMkeP`,
	"padding1": `EditBlogDetails-padding1-BIcss`,
	"padding2": `EditBlogDetails-padding2-rw3No`,
	"padding3": `EditBlogDetails-padding3-sB2fW`,
	"padding4": `EditBlogDetails-padding4-cu5vq`,
	"padding5": `EditBlogDetails-padding5-Uorvz`,
	"padding6": `EditBlogDetails-padding6-v0JCQ`,
	"padding7": `EditBlogDetails-padding7-J3ZpO`,
	"paddingTop1": `EditBlogDetails-paddingTop1-psuLC`,
	"paddingTop2": `EditBlogDetails-paddingTop2-RwdPc`,
	"paddingTop3": `EditBlogDetails-paddingTop3-xJq3u`,
	"paddingTop4": `EditBlogDetails-paddingTop4-ASHJ_`,
	"paddingTop5": `EditBlogDetails-paddingTop5-oabcc`,
	"paddingTop6": `EditBlogDetails-paddingTop6-g7qM5`,
	"paddingTop7": `EditBlogDetails-paddingTop7-xKUCO`,
	"noPadding": `EditBlogDetails-noPadding-dlsIF`,
	"textBold": `EditBlogDetails-textBold-ub_b7`,
	"textBolder": `EditBlogDetails-textBolder-hqnwx`,
	"textNormal": `EditBlogDetails-textNormal-asP7D`,
	"spaceBottom20": `EditBlogDetails-spaceBottom20-ucbf5`,
	"spaceBottom10": `EditBlogDetails-spaceBottom10-LsfE2`,
	"marginNone": `EditBlogDetails-marginNone-WyU_d`,
	"spaceBottom15": `EditBlogDetails-spaceBottom15-X4mwU`,
	"marginTopNone": `EditBlogDetails-marginTopNone-gUYuF`,
	"spaceTop11": `EditBlogDetails-spaceTop11-MyAoQ`,
	"spaceTop21": `EditBlogDetails-spaceTop21-lWqev`,
	"spaceTop20": `EditBlogDetails-spaceTop20-xtYB4`,
	"spaceTop10": `EditBlogDetails-spaceTop10-ZuZ2d`,
	"textDarkBlue": `EditBlogDetails-textDarkBlue-CXXg8`,
	"textLightBlue": `EditBlogDetails-textLightBlue-kCO3C`,
	"textLightSandleGreen": `EditBlogDetails-textLightSandleGreen-TV3Gn`,
	"textLightBrown": `EditBlogDetails-textLightBrown-Chrrs`,
	"textMediumMaroon": `EditBlogDetails-textMediumMaroon-shzxs`,
	"textBrown": `EditBlogDetails-textBrown-SiHYH`,
	"textMaroon": `EditBlogDetails-textMaroon-yVMWU`,
	"textDarkBrown": `EditBlogDetails-textDarkBrown-hE8Ar`,
	"textMediumBrown": `EditBlogDetails-textMediumBrown-aWcmo`,
	"textSkyBlue": `EditBlogDetails-textSkyBlue-tC_rp`,
	"textGray": `EditBlogDetails-textGray-cA7_0`
};
module.exports = ___CSS_LOADER_EXPORT___;
